import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export type ImportType = 'accounts' | 'transactions' | 'contacts';

export interface ImportAnalysis {
    id: string;
    type: ImportType;
    summary: string;
    itemCount: number;
    previewItems: any[];
    potentialConflicts: string[];
}

@Injectable({
    providedIn: 'root'
})
export class ImportService {
    private apiUrl = environment.apiUrl;

    constructor(private http: HttpClient) { }

    analyzeFile(file: File, type: ImportType): Observable<ImportAnalysis> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('type', type);
        // In a real app, this might be a multi-part post to an AI-powered endpoint
        return this.http.post<ImportAnalysis>(`${this.apiUrl}/import/analyze`, formData);
    }

    executeImport(analysisId: string): Observable<{ success: boolean; count: number }> {
        return this.http.post<{ success: boolean; count: number }>(`${this.apiUrl}/import/execute`, { analysisId });
    }
}
